import { ChecklistType } from "../../entities";
import GatewayRecordParser from "./GatewayRecordParser";
import { isRecord, isReplaceChange } from "../types";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, getChecklistSchema, getRemarksSchema } from "../../utils";
const CHECKLIST_TYPE_EXTENSION = 'ChecklistType';
export default class ChecklistParser extends GatewayRecordParser {
    constructor(app) {
        super(app);
    }
    getTypeId(protocol) {
        if (!('_id' in protocol.type)) {
            return protocol.type.ref._id;
        }
        throw new Error(`Parser does not support protocols of type ProtocolType`);
    }
    getRecordTypeExtension(protocol) {
        return {
            Manufacturer: 'ANZ',
            Name: CHECKLIST_TYPE_EXTENSION,
            Value: this.getTypeId(protocol),
        };
    }
    handlesProtocol(protocol) {
        if ('_id' in protocol.type) {
            return false;
        }
        try {
            this.localCache.getChecklistType(protocol.type.ref._id);
            return true;
        }
        catch (error) {
            return false;
        }
    }
    getChecklistType(record) {
        let extensions = [];
        if (isRecord(record)) {
            extensions = record.Extensions || [];
        }
        else if (isReplaceChange(record.Changes[0])) {
            extensions = record.Changes[0].ReplacementRecord.Extensions || [];
        }
        else {
            extensions = record.Changes[0].Extensions || [];
        }
        const checklistTypes = this.localCache.getChecklistTypes(true);
        const recordTypeExtension = extensions.find((extension) => extension.Manufacturer === 'ANZ' &&
            extension.Name === CHECKLIST_TYPE_EXTENSION &&
            checklistTypes.some((checklistType) => checklistType._id === extension.Value));
        if (!recordTypeExtension) {
            throw new Error(`Checklist type for record can not be determined because extension missing.`);
        }
        return this.localCache.getChecklistType(recordTypeExtension.Value);
    }
    getTypeRefForProtocol(record) {
        return { type: 'checklist', ref: ChecklistType.createRef(this.getChecklistType(record)._id) };
    }
    handlesRecord(record) {
        try {
            this.getChecklistType(record);
            return true;
        }
        catch (error) {
            return false;
        }
    }
    createEntries(checklist) {
        return [...this.createEntriesForCheckpoints(checklist), ...this.createEntriesForRemarks(checklist)];
    }
    createEntriesForCheckpoints(checklist) {
        const checklistTypeId = !('_id' in checklist.type) ? checklist.type.ref._id : '';
        const contents = checklist.contents.find((content) => content.type._id === checklistTypeId);
        const checklistType = this.localCache.getChecklistType(checklistTypeId);
        const schema = getChecklistSchema(checklistType);
        return this.createSchemaEntries(checklist, contents, schema);
    }
    createEntriesForRemarks(checklist) {
        const contents = checklist.contents.find((content) => content.type._id === FIXED_PROTOCOL_CONTENT_TYPE_IDS.REMARKS);
        const schema = getRemarksSchema('Remarks');
        return this.createSchemaEntries(checklist, contents, schema);
    }
    parseProtocolContent(record) {
        const encryptedContent = this.parseEncryptedContent(record);
        if (encryptedContent) {
            return [encryptedContent];
        }
        const checklistType = this.getChecklistType(record);
        const schema = getChecklistSchema(checklistType);
        const remarksSchema = getRemarksSchema('Remarks');
        const remarksData = this.parseSchemaData(record, remarksSchema);
        return [
            { type: ChecklistType.createRef(checklistType._id), data: this.parseSchemaData(record, schema) },
            { type: { _id: FIXED_PROTOCOL_CONTENT_TYPE_IDS.REMARKS }, data: remarksData },
        ];
    }
}
//# sourceMappingURL=ChecklistParser.js.map